import { ApiRoutesFacets } from "griptonite-api-client";

import { RoutesFacets } from "../RoutesTable/useFilteredRoutes";

export const apiFacetsToRoutesFacets = (apiFacets: ApiRoutesFacets): RoutesFacets => {
  const circuitsMap = new Map(
    apiFacets.circuit.map((r) => [
      r.value ? `circuit:${r.value}` : r.value,
      { ...r, value: r.value ? `circuit:${r.value}` : r.value },
    ]),
  );

  apiFacets.competition.forEach((competition) => {
    if (competition.value) {
      circuitsMap.set(`competition:${competition.value}`, {
        ...competition,
        name: "Event: " + competition.name,
        value: `competition:${competition.value}`,
      });
    }
  });

  const result = {
    circuit: circuitsMap,
    setters: new Map(apiFacets.setters.map((r) => [r.value, r])),
    zone: new Map(apiFacets.zone.map((r) => [r.value, r])),
    startLine: new Map(apiFacets.startLine.map((r) => [r.value, r])),
    styles: new Map(apiFacets.styles.map((r) => [r.value, r])),
    skills: new Map(apiFacets.skills.map((r) => [r.value, r])),
    holds: new Map(apiFacets.holds.map((r) => [r.value, r])),
    holdColors: new Map(apiFacets.holdColors.map((r) => [r.value, r])),
    // The archive doesn't filter by label yet.
    labels: new Map(),
    competitionCategories: new Map(),
    gradeValue: new Map(apiFacets.gradeValue.map((r) => [r.value, r])),
    ascentStyle: new Map(apiFacets.ascentStyle.map((r) => [r.value, r])),
  };

  return result;
};
